import PromoCodesLayout from '@playground/features/promo-codes/PromoCodesLayout'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_partners/promo-codes')({
  component: PromoCodesLayout,
})
